import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { 
  Building2, 
  Calendar, 
  Carrot, 
  Settings, 
  Users,
  Home,
  Bell,
  X
} from 'lucide-react';

interface SidebarProps {
  onClose?: () => void;
}

const navItems = [
  { icon: Home, label: 'Home', to: '/dashboard', exact: true },
  { icon: Building2, label: 'Anlagen', to: '/dashboard/facilities' },
  { icon: Calendar, label: 'Buchungen', to: '/dashboard/bookings' },
  { icon: Carrot, label: 'Pferde', to: '/dashboard/horses' },
  { icon: Users, label: 'Mitglieder', to: '/dashboard/members' },
  { icon: Bell, label: 'Benachrichtigungen', to: '/dashboard/notifications' },
  { icon: Settings, label: 'Einstellungen', to: '/dashboard/settings' },
];

export const Sidebar: React.FC<SidebarProps> = ({ onClose }) => {
  const location = useLocation();

  const isLinkActive = (to: string, exact?: boolean) => {
    if (exact) {
      return location.pathname === to;
    }
    return location.pathname.startsWith(to);
  };

  return (
    <div className="flex h-full flex-col bg-white dark:bg-gray-800">
      {/* Sidebar header */}
      <div className="flex h-16 shrink-0 items-center justify-between px-4 border-b border-gray-200 dark:border-gray-700">
        <div className="flex items-center">
          <Building2 className="h-8 w-8 text-indigo-600 dark:text-indigo-400" />
          <span className="ml-2 text-lg font-semibold text-gray-900 dark:text-white">
            Equisuite
          </span>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="lg:hidden p-2 rounded-md text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
          >
            <span className="sr-only">Menü schließen</span>
            <X className="h-6 w-6" />
          </button>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-1 space-y-1 px-2 py-4 overflow-y-auto">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            onClick={onClose}
            className={
              isLinkActive(item.to, item.exact)
                ? 'flex items-center px-3 py-3 text-sm font-medium rounded-md bg-indigo-50 dark:bg-indigo-900/50 text-indigo-600 dark:text-indigo-300'
                : 'flex items-center px-3 py-3 text-sm font-medium rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors'
            }
          >
            <item.icon className="h-5 w-5 mr-3 shrink-0" />
            <span className="truncate">{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
};
